.bottom-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: calc(7 * var(--spacer));
  border-top: 1px solid var(--chart-101-pressed-dividers);
  padding-left: calc(5 * var(--spacer));
  padding-right: calc(5 * var(--spacer));

  gz-button {
    margin-right: calc(2 * var(--spacer));
  }
}

.flex-auto {
  flex: auto;
}

.infoText {
  margin-left: var(--spacer);
}
